import script from "./AddUsersToWorkspaceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUsersToWorkspaceModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUsersToWorkspaceModal.vue?vue&type=style&index=0&id=4646f107&lang=scss&scoped=true"
import "./AddUsersToWorkspaceModal.vue?vue&type=style&index=1&id=4646f107&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4646f107"]])

export default __exports__